import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { About } from "@/components/site/About";
import { Marquee } from "@/components/site/Marquee";
import { Magazine } from "@/components/site/Magazine";
import { Entertainment } from "@/components/site/Entertainment";
import { B2B } from "@/components/site/B2B";
import { Contact } from "@/components/site/Contact";

function App() {
  useEffect(() => {
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) return;

    const lenis = new Lenis({
      duration: 1.15,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });
    window.__lenis = lenis;

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="App grain relative min-h-screen bg-champagne">
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#251504",
            color: "#EFDFBB",
            border: "1px solid rgba(198,145,47,0.4)",
            fontFamily: "Jost, sans-serif",
          },
        }}
      />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Marquee />
        <Magazine />
        <Entertainment />
        <B2B />
        <Contact />
      </main>
    </div>
  );
}

export default App;
